import {Link} from "react-router-dom";

const BreadcrumbsComponent = ({linkList}) => {
    const lengthList = linkList.length;
    
    return(
        <div className="bg-white/60 backdrop-blur-sm border border-white/30 rounded-2xl p-4 shadow-lg">
            <nav className="flex items-center space-x-2 text-sm font-medium">
                {linkList.map(({name, linkUrl}, index) => {
                    const isLast = lengthList - index === 1;
                    
                    return (
                        <div key={index} className="flex items-center">
                            {!isLast ? (
                                <>
                                    <Link 
                                        to={linkUrl}
                                        className="text-slate-600 hover:text-blue-600 transition-colors duration-200 hover:underline"
                                    >
                                        {name}
                                    </Link>
                                    <svg className="w-4 h-4 mx-2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </>
                            ) : (
                                <span className="text-slate-800 font-semibold">{name}</span>
                            )}
                        </div>
                    );
                })}
            </nav>
        </div>
    )
}
export default BreadcrumbsComponent;